import { Component, ViewChild, OnInit } from '@angular/core';
import { DxDataGridComponent, DxDataGridTypes, } from 'devextreme-angular/ui/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import { VehicleInquiryService } from 'src/app/shared/services/vehicle-inquiry.service';
import { DataGridConfigService } from 'src/app/shared/services/dataGridConfigService ';
import { NumberFormatterPipe } from 'src/app/shared/pipes/number-formatter.pipe';
import { CityService } from 'src/app/shared/services/city.service';
import { VisaApplicationService } from 'src/app/shared/services/visa-application.service';
import { VisaApplicationStatusDto } from 'src/app/shared/dtos/visa-application/visa-application.dto';
import { PaymentStatus, PaymentStatusLabel } from 'src/app/shared/enums/paymentStatus';
import { VisaStatusService } from 'src/app/shared/services/visa-status.service';
import { firstValueFrom } from 'rxjs';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { DataSourceService } from 'src/app/shared/services/data-source-service.ts';


@Component({
  selector: 'app-visa-application-list',
  templateUrl: './visa-application-list.component.html',
  styleUrls: ['./visa-application-list.component.scss'],
  providers:[NumberFormatterPipe]
})
export class VisaApplicationListComponent implements OnInit {

  rules = { X: /[02-9]/ };
  @ViewChild(DxDataGridComponent, { static: true })
  dataGrid!: DxDataGridComponent;
  closeButtonOptions: Record<string, unknown>;
  dataSource = {} as CustomStore

  popupVisible = false;
  selectedVisaApplication: any;

  visaApplications: any;
  paymentStatusLookup: { value: number; text: string }[] = [];
  visaStatuses: any;


  paymentCounts = {
    paid: 0,
    pending: 0,
    transferAwaiting: 0,
    rejected: 0
  };
  private countIntervalRef: any;

  cities:any
  years:any
  brands:any
  models:any
  series:any
  unLimitedGsmNumber:string=''
  booleanType: any= [{id:true, name:"Evet"},{id:false, name:"Hayır"} ]

  constructor(private visaApplicationService: VisaApplicationService,
    private dataGridConfigService: DataGridConfigService,
    private numberFormatterPipe: NumberFormatterPipe,
    private visaStatusService: VisaStatusService,
    private notificationService: NotificationService,
    private loadingService: LoadingService,
    private dataSourceService: DataSourceService,
  ) {

    this.dataGridConfigService.setGridExportName('Vize Başvuruları');

    this.closeButtonOptions = {
      text: 'Close',
      stylingMode: 'outlined',
      type: 'normal',
      onClick: () => {
        this.refresh()
        this.popupVisible = false;
      },
    };

    // this.vehicleInquiriesService.getDataSource().then((dataSource) => { this.dataSource = dataSource; });
  }

  ngOnInit(): void {
    this.initializeDataSource();
    this.startPaymentCountLoop();
    this.preparePaymentStatusLookup();
    this.getVisaStatuses();
  }

  async initializeDataSource(): Promise<void> {
    this.dataSource = this.visaApplicationService.getVisaApplicationDataSource();
  }

  ngOnDestroy(): void {
    if (this.countIntervalRef) {
      clearInterval(this.countIntervalRef);
    }
  }

  startPaymentCountLoop(): void {
    this.getPaymentCounts(); // ilk çağır
  
    this.countIntervalRef = setInterval(() => {
      this.getPaymentCounts();
    }, 30000); // 30 saniyede bir
  }

  getPaymentCounts(): void {
    this.visaApplicationService.getPaymentCounts().subscribe((data) => {
      this.paymentCounts.paid = data.paid;
      this.paymentCounts.pending = data.pending;
      this.paymentCounts.transferAwaiting = data.transferAwaiting;
      this.paymentCounts.rejected = data.rejected;
    });
  }

  // getList() {
  //   this.visaApplicationService.getVisaApplicationList().subscribe(data => {
  //     this.visaApplications = data.data
  //   });
  // }

  getVisaStatuses(){
     this.visaStatusService.getAll().subscribe(data => {
      this.visaStatuses = data;
    })
  }

  preparePaymentStatusLookup() {
    this.paymentStatusLookup = Object.keys(PaymentStatusLabel).map(key => ({
      value: Number(key),
      text: PaymentStatusLabel[Number(key)]
    }));
  }


  async onRowUpdating(e: any) {
    this.loadingService.show();
    try
    {
      const oldData = e.oldData;
      const newData = e.newData;
    
      const updatedData: VisaApplicationStatusDto = {
        id: oldData.id,
        customerId: oldData.visaApplicationCustomerId,
        paymentStatus: newData.visaPaymentStatus ?? oldData.visaPaymentStatus,
        visaStatusId: newData.visaStatus ?? oldData.visaStatus,

      };
    
      await firstValueFrom(this.visaApplicationService.updateStatus(updatedData));
      this.getPaymentCounts();
      this.notificationService.show('Vize başvuru bilgileri başarıyla güncellendi.');
    }catch{
      this.getPaymentCounts();
    }finally{
      this.loadingService.hide();
    }
  }

  // getById(id: number) {
  //   this.vehicleInquiriesService.getById(id).subscribe();
  // }

  // update() {
  //   this.vehicleInquiriesService.update(this.selectedVisaApplication.id, this.selectedVisaApplication).subscribe()
  // }

  rowClick(e: DxDataGridTypes.RowClickEvent) {
    this.popupVisible = true;
    this.selectedVisaApplication = e.data;
  }
  refresh = () => {
    this.dataGrid.instance.refresh();
  };
  getRowNumber(rowIndex: number): number {
    const pageIndex = this.dataGrid.instance.pageIndex(); // Mevcut sayfa numarası
    const pageSize = this.dataGrid.instance.pageSize(); // Sayfa başına kayıt sayısı
    return pageIndex * pageSize + rowIndex + 1;
  }
  getNumberFormatter(number:any){
    return this.numberFormatterPipe.transform(number)
  }

  getPaymentStatusLabel(value: number): string {
    return PaymentStatusLabel[value] || '';
  }
  
  // Stil belirleme fonksiyonu
  getPaymentStatusClass(value: number): string {
    switch (value) {
      case PaymentStatus.Pending:
        return 'text-primary'; // Mavi
      case PaymentStatus.Approved:
        return 'text-success'; // Yeşil
      case PaymentStatus.Rejected:
        return 'text-danger'; // Kırmızı
      case PaymentStatus.Unpaid:
        return 'text-warning'; // turuncu
      default:
        return '';
    }
  }

  getVisaStatusLabel(value: number): string {
    const status = this.visaStatuses.find((x: any) => x.id === value);
    const label = status ? status.name : '';
    return label.toUpperCase();
  }
  
  
  getVisaStatusClassByText(value: number): string {
    const status = this.visaStatuses.find((x:any) => x.id === value);
    if (!status) return '';
    switch (status.name.toLowerCase()) {
      case 'onaylandi':
        return 'text-success';
      case 'reddedi̇ldi̇':
        return 'text-danger';
      case 'i̇şlemde':
        return 'text-primary';
      default:
        return '';
    }
  }
  
  

  // onRowPrepared(event:any){
  //   console.log('event.data', event.data);
  //   if(event.rowType == 'data' && event.data.visaPaymentStatus == PaymentStatus.Approved){
  //     event.rowElement.style.backgroundColor = '#ddeedf';  
  //     event.rowElement.className = event.rowElement.className.replace("dx-row-alt", "");  
  //   }
  //  else if(event.rowType == 'data' && event.data.visaPaymentStatus != PaymentStatus.Approved){
  //   event.rowElement.style.backgroundColor = '#ff4500';  
  //   event.rowElement.className = event.rowElement.className.replace("dx-row-alt", "");  
  //  }
  // }

  getInvoiceStatusLabel(value: boolean): string {
    return value ? 'KESİLDİ' : 'KESİLMEDİ';
  }

  getInvoiceStatusClass(value: boolean): string {
    return value ? 'text-success' : 'text-danger';
  }

}
